import { call } from "./utils";

export const getTeamCollection = async (data) =>
  await call({ url: "/get/team/collection", data: { data } });

export const createGroupByCollection = async (data) =>
  await call({ url: "/create/group/by/collection", data: { data } });
